
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/index-public",
      function () {
        return require("private-next-pages/index-public.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/index-public"])
      });
    }
  